export const currency = {
    1: "MYR", 
    4: "IDR"
};